const listenForResponseOnVoipContent = () => {
  return null;
};

export default listenForResponseOnVoipContent;
